import { render, staticRenderFns } from "./DefaultLayout.vue?vue&type=template&id=57dada0c&scoped=true&"
import script from "./DefaultLayout.vue?vue&type=script&setup=true&lang=js&"
export * from "./DefaultLayout.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./DefaultLayout.vue?vue&type=style&index=0&id=57dada0c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57dada0c",
  null
  
)

export default component.exports